module.exports = __webpack_public_path__ + "static/img/img_title_pt.6a1a656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_pt.png
// module id = xYts
// module chunks = 1